import { jsx as _jsx } from "react/jsx-runtime";
import { pathgen } from 'object-path-generator';
import { ConfirmationModal, useOverlayContext } from 'seagull';
import { useLocaleKeys } from '~/i18n';
import { useStoreActions } from '~/store/store-context';
import { useMutationState } from '../useMutationState';
export const useCancelEditProposalTestIds = pathgen('useCancelEditProposalTestIds');
export const useCancelEditProposal = function useCancelEditProposal() {
    let { onSuccess } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { api } = useStoreActions();
    const overlayContext = useOverlayContext();
    const { t: editInPlaceTexts } = useLocaleKeys('proposal.studio.editInPlace');
    const { mutate, isLoading } = useMutationState({
        mutationFn: (relationshipId)=>api.relationship.cancelEdit(relationshipId),
        withPageLoader: true,
        mutationName: 'cancel-edit-proposal',
        toasts: {
            errorMessage: editInPlaceTexts.cancelEditErrorToast(),
            errorTestId: useCancelEditProposalTestIds.ErrorToast()
        },
        onSuccess: ()=>{
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
        }
    });
    const cancelEditWithConfirmation = async (relationshipId)=>{
        const confirmed = await overlayContext.showModal({
            biName: 'cancel_edit_proposal_cancel_edit_confirmation_confirm',
            closeOnClickOutside: true,
            closeOnEscapeKey: true,
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(ConfirmationModal, {
                    bi: {
                        primaryButton: {
                            name: 'use_cancel_edit_proposal_confirm'
                        },
                        secondaryButton: {
                            name: 'use_cancel_edit_proposal_cancel'
                        }
                    },
                    skin: "danger",
                    title: editInPlaceTexts.cancelEditConfirmationTitle(),
                    content: editInPlaceTexts.cancelEditConfirmationContent(),
                    primaryButtonLabel: editInPlaceTexts.cancelEditConfirmationPrimaryButton(),
                    secondaryButtonLabel: editInPlaceTexts.cancelEditConfirmationSecondaryButton(),
                    onPrimaryButtonClick: ()=>dismissModal(true),
                    onSecondaryButtonClick: ()=>dismissModal(false)
                });
            }
        });
        if (!confirmed) return;
        mutate(relationshipId);
    };
    return {
        cancelEditProposal: cancelEditWithConfirmation,
        isCancelling: isLoading
    };
};
